import React from 'react';
import { Box, Button } from '@mui/material';
import { Add as AddIcon, Link as LinkIcon } from '@mui/icons-material';
import { trackButtonClick } from '../../utils/gtm';

const ProjectsCreateAndLink = ({ onAddProject, onLinkExisting }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: { xs: 'stretch', sm: 'flex-end' }, 
      alignItems: 'center',
      width: { xs: '100%', sm: 'auto' }
    }}>
      {/* Action Buttons */}
      <Box sx={{ 
        display: 'flex', 
        gap: { xs: 1.5, sm: 2 }, 
        justifyContent: { xs: 'stretch', sm: 'flex-end' },
        flexDirection: { xs: 'column', sm: 'row' },
        width: { xs: '100%', sm: 'auto' }
      }}>
        <Button
          variant="outlined"
          startIcon={<LinkIcon />}
          onClick={() => {
            try {
              trackButtonClick('link_existing_project', 'projects_page');
            } catch (error) {
              console.error('Analytics tracking failed:', error);
            }
            onLinkExisting();
          }}
          sx={{
            borderRadius: 1,
            px: 3,
            py: 1.5,
            fontWeight: 600,
            fontSize: '0.875rem',
            borderColor: '#E2E8F0',
            color: '#475569',
            textTransform: 'none',
            width: { xs: '100%', sm: 'auto' },
            '&:hover': {
              borderColor: '#CBD5E1',
              bgcolor: '#F8FAFC',
            },
          }}
        >
          Link Existing
        </Button>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => {
            try {
              trackButtonClick('add_new_project', 'projects_page');
            } catch (error) {
              console.error('Analytics tracking failed:', error);
            }
            onAddProject();
          }}
          sx={{
            borderRadius: 1,
            px: 3,
            py: 1.5,
            fontWeight: 600,
            fontSize: '0.875rem',
            bgcolor: '#1f1f1f',
            color: '#fff',
            textTransform: 'none',
            width: { xs: '100%', sm: 'auto' },
            '&:hover': {
              bgcolor: '#0F172A',
            },
          }}
        >
          Add New Project
        </Button>
      </Box>
    </Box>
  );
};

export default ProjectsCreateAndLink;